import React from 'react'
import InstructorNavbar from "../components/instructor/InstructorNavbar"
import Instructorslist from '../components/courseContent/Instructorslist'

const InstructorlistPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <Instructorslist/>
    </>
  )
}

export default InstructorlistPage